import { Settings } from './namespace-helper'

export default {
  handleApiError (store, err) {
    try {
      err.message = err.response.data.message
      if (err.response.data.errors != null) {
        err.message = err.message + ' ' + JSON.stringify(err.response.data.errors)
      }
      console.log('response: ' + JSON.stringify(err))
    } catch (ex) {
      console.log(JSON.stringify(ex))
    }
    store.commit(Settings.mutations.setLoading, false)

    if (err.response != null) {
      store.commit(Settings.mutations.setNetworkError, err)
    } else {
      store.commit(Settings.mutations.setNetworkError, {
        message: 'Network Error -> please check your internet connection!'
      })
    }
  },
  clear (store) {
    store.commit(Settings.mutations.setNetworkError, null)
  }
}



// WEBPACK FOOTER //
// ./src/store/ErrorHandler.js